/**
 * Created by fers on 27.04.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import FormFields from '../../fw/FormFields.react';

import {actionOperations} from '../../../common/model-api/ActionDefType';

export default class Parent extends React.Component {

    static propTypes = {
        data: PropTypes.object.isRequired,
        setProperty: PropTypes.func.isRequired,
    };

    constructor(props, displayName) {
        super(props);

        this.displayName = displayName;
    }

    defaultMetaData(list) {

        let values = {};

        for (let key of Object.keys(actionOperations)) {
            values[key] = {
                name: actionOperations[key].name,
                disabled: (value) => {
                    if (value['actionType'] && value['actionType'].indexOf("all") !== -1) {
                        return true;
                    } else {
                        return false;
                    }
                },
            };
        }

        list["actionType"] = {
            name: "Action Type",
            type: "enums",
            defaultValue: ["all"],
            values: {
                "all": {
                    name: "All"
                },
                ...values
            }
        };

        return list;
    }

    //collectMetaData() {
    //    throw new Error("Not implemented");
    //}

    _onChangeAddon = (column, addons) => {
        addons['onChange'] = (e, value) => {
            return this.props.setProperty(column, value);
        };

        return addons;
    };

    render() {
        if (!this.metadata) {
            this.metadata = this.collectMetaData();
        }

        return (
            <div>
                <h3>{this.displayName}</h3>
                <FormFields
                    data={this.props.data}
                    metadata={this.metadata}
                    onField={this._onChangeAddon}
                    showAll
                />
            </div>
        );
    }
}


